import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './Support.css';

const guides = [
  { title: 'Sign Up / Login', desc: 'Easily register or log in to your JustService24 account.' },
  { title: 'Business Listing', desc: 'List your business with complete details and photos.' },
  { title: 'Adset Upload', desc: 'Upload promotional banners and sponsored ads easily.' },
  { title: 'Human Resource', desc: 'Post jobs, manage applicants, and hire talent.' },
  { title: 'Digital Poster', desc: 'Create and share beautiful digital posters instantly.' },
  { title: 'Visiting Card', desc: 'Design and share your digital visiting card.' },
];

const faqs = [
  { q: 'How do I list my business on JustService24?', a: "Go to Home → Our Services → List Your Business, fill in your details and submit. It's completely FREE!" },
  { q: 'How to book appointments or services?', a: 'Browse any business listing and tap the contact/book button to connect with the service provider directly.' },
  { q: 'How do I contact customer support?', a: 'Use the form above to submit your issue. You can also reach us at support@justservice24.com. We respond within 24 hours.' },
  { q: 'Is the app available in multiple languages?', a: 'Currently JustService24 is available in English and Hindi. More languages will be added soon.' },
  { q: 'Is my information secure?', a: 'Yes! JustService24 uses secure encryption to protect your personal data. We never share your information with third parties.' },
  { q: 'What services are available?', a: 'JustService24 offers Business Listing, Digital Poster, Digital Visiting Card, Human Resources, AdSet advertising, and much more.' },
  { q: 'Is JustService24 free to use?', a: 'Yes, basic features like business listing, digital poster and visiting card are free. Premium features like AdSet have paid plans.' },
  { q: 'What payment methods are accepted?', a: 'We accept UPI, Net Banking, Credit/Debit Cards and Wallets for premium services.' },
  { q: 'How to update my profile?', a: 'Go to Account → tap the edit icon next to your name → update your details and save.' },
  { q: 'Facing technical issues?', a: 'Try refreshing the page. If the issue persists, use the form above to report the problem with details.' },
  { q: 'How to create a business account?', a: 'Login with your mobile number → go to Account → tap Business → Add Business and fill in your business details.' },
];

export default function SupportCenter() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !desc.trim()) { setError('Please fill all fields'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/api/support', { title: title.trim(), description: desc.trim() });
      setTitle(''); setDesc('');
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      setError(err.response?.data?.message || 'Submission failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="support-page">
      {submitted && (
        <div className="support-success-overlay" onClick={() => setSubmitted(false)}>
          <div className="support-success-box" onClick={e => e.stopPropagation()}>
            <div className="support-success-icon">✅</div>
            <h3>Request Submitted!</h3>
            <p>Your request has been sent successfully. Our team will get back to you within 24 hours.</p>
          </div>
        </div>
      )}
      <div className="support-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
          <h1>Support Center</h1>
        </div>
      </div>

      <div className="container">
        {/* Submit Form */}
        <div className="support-card">
          <h2>📝 Submit a Request</h2>
          <form onSubmit={handleSubmit} className="support-form">
            <div className="sf-group">
              <label>Title*</label>
              <input placeholder="Title" value={title} onChange={e => { setTitle(e.target.value); setError(''); }} />
            </div>
            <div className="sf-group">
              <label>Description*</label>
              <textarea rows={5} placeholder="Write Your Problem in Details" value={desc}
                onChange={e => { setDesc(e.target.value); setError(''); }} />
            </div>
            {error && <div className="support-error-msg">{error}</div>}
            <button type="submit" className="btn-submit-support" disabled={loading}>
              {loading ? '⏳ Submitting...' : 'Submit'}
            </button>
          </form>
        </div>

        {/* Download Manual Guide */}
        <h2 className="section-title-support">📚 Download Manual Guide</h2>
        <div className="guides-list">
          {guides.map((g, i) => (
            <div key={i} className="guide-card">
              <div className="guide-icon">📖</div>
              <div className="guide-info">
                <h4>{g.title}</h4>
                <p>{g.desc}</p>
              </div>
              <button className="btn-view-guide" onClick={() => alert('Guide will be available soon!')}>
                View Now
              </button>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <h2 className="section-title-support">❓ Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item ${openFaq === i ? 'open' : ''}`}>
              <div className="faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{faq.q}</span>
                <span className="faq-arrow">{openFaq === i ? '▲' : '▼'}</span>
              </div>
              {openFaq === i && <div className="faq-a">{faq.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
